(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-result.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-map/assets/javascripts/map-result.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const logger = svs.core.log.getLogger('module:lyckoplatsen');
const _svs$tur$lyckoplatsen = svs.tur.lyckoplatsen.map,
  createMap = _svs$tur$lyckoplatsen.createMap,
  mapDefaults = _svs$tur$lyckoplatsen.mapDefaults,
  sweRectangleBounds = _svs$tur$lyckoplatsen.sweRectangleBounds,
  locationToArray = _svs$tur$lyckoplatsen.locationToArray,
  get3dPinIcon = _svs$tur$lyckoplatsen.get3dPinIcon,
  getSouthCoordinate = _svs$tur$lyckoplatsen.getSouthCoordinate,
  checkDuplicateWagersLocations = _svs$tur$lyckoplatsen.checkDuplicateWagersLocations;
const productMapping = svs.lyckoplatsen.components.shared_constants.productMapping;
const formatCurrency = svs.utils.format.Currency;
function getResultMapHandler() {
  let map;
  let mapId;
  let intervalPins = [];
  let wagerPins = [];
  let singleCircles = [];
  let singelPin;
  let circleIndex = 0;
  let winningCoord;
  let singleWinGroups = [];
  let mapLayers = [];
  let showCenterSwedenButton = true;
  let showCenterWagersButton = false;
  let showCenterWinCircleButton = false;
  let justMovedToCenter = true;
  let maxZoom;
  let minZoom;
  let tlResult;
  const eventHandlers = {};
  const trackMapLayers = e => mapLayers.push(e.layer);

  let _isDestroying = false;

  const svgRenderer = leaflet.svg({
    padding: 0.85
  });
  return {
    createMap(_ref) {
      let _ref$mapOptions = _ref.mapOptions,
        mapOptions = _ref$mapOptions === void 0 ? {} : _ref$mapOptions,
        _ref$evtHandlers = _ref.evtHandlers,
        evtHandlers = _ref$evtHandlers === void 0 ? {} : _ref$evtHandlers;
      Object.assign(eventHandlers, evtHandlers);
      const options = _objectSpread(_objectSpread({}, mapDefaults), mapOptions);
      mapId = options.nodeId;

      const el = document.getElementById(mapId);
      if (el && el._leaflet_id) {
        el._leaflet_id = null;
      }
      if (map) {
        map.remove();
        map = null;
      }
      map = createMap(options);
      maxZoom = options.maxZoom;
      minZoom = options.minZoom;
      this.setupZoomListeners();
      map.on('resize', _.debounce(() => this.updateUI(circleIndex), 300));
      map.on('moveend', () => {
        window.requestAnimationFrame(() => this.uiStamp(circleIndex));
      });
      map.on('move', () => {
        if (!justMovedToCenter) {
          showCenterWinCircleButton = true;
          showCenterWagersButton = true;
          showCenterSwedenButton = true;
          this.showUiCenterWinCircle();
          this.showUiCenterWagers();
          this.showUiCenterSweden();
        }
        justMovedToCenter = false;
      });
      return map;
    },
    setupZoomListeners() {
      map.whenReady(() => {
        const mapContainer = document.getElementById(mapId);
        const zoomInButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-in');
        const zoomOutButton = mapContainer === null || mapContainer === void 0 ? void 0 : mapContainer.querySelector('.leaflet-control-zoom-out');
        zoomInButton.addEventListener('click', () => this.applyZoom(1));
        zoomOutButton.addEventListener('click', () => this.applyZoom(-1));
      });
    },
    applyZoom(zoomDirection) {
      const currentZoom = map.getZoom();
      const newZoom = currentZoom + zoomDirection;
      showCenterWagersButton = true;
      showCenterWinCircleButton = true;
      map.setView(map.getCenter(), newZoom, {
        animate: false
      });
      this.uiStamp(circleIndex);
      this.showUiCenterWinCircle();
      this.showUiCenterWagers();
    },
    fitBoundsSweden() {
      var _map;
      (_map = map) === null || _map === void 0 || _map.fitBounds(sweRectangleBounds, {
        minZoom,
        maxZoom,
        animate: false
      });
    },
    selectSinglePin() {
      this.moveToWinGroup(singleWinGroups.length - 1);
    },
    clearSelectedSinglePin() {
    },
    removeIntervalResult() {
      intervalPins.forEach(pin => {
        var _pin$remove;
        return pin === null || pin === void 0 || (_pin$remove = pin.remove) === null || _pin$remove === void 0 ? void 0 : _pin$remove.call(pin);
      });
      intervalPins = [];
    },
    centerSweden() {
      var _map2;
      showCenterWinCircleButton = true;
      showCenterWagersButton = true;
      showCenterSwedenButton = false;
      circleIndex = 0;
      justMovedToCenter = true;
      this.showUiCenterWinCircle();
      this.showUiCenterSweden();
      (_map2 = map) === null || _map2 === void 0 || _map2.fitBounds(sweRectangleBounds, {
        animate: false,
        padding: [45, 15],
        minZoom,
        maxZoom
      });
      this.updateUI();
    },
    centerWinCircle() {
      var _singleCircles$;
      showCenterWinCircleButton = false;
      showCenterWagersButton = true;
      showCenterSwedenButton = true;
      circleIndex = 0;
      justMovedToCenter = true;
      const bounds = (_singleCircles$ = singleCircles[0]) === null || _singleCircles$ === void 0 ? void 0 : _singleCircles$.getBounds();
      if (bounds && bounds !== null && bounds !== void 0 && bounds.isValid()) {
        var _map3;
        (_map3 = map) === null || _map3 === void 0 || _map3.fitBounds(bounds, {
          animate: false,
          minZoom,
          maxZoom
        });
      }
      this.updateUI();
    },
    centerWagers() {
      var _leaflet$featureGroup, _singleCircles$2;
      showCenterWinCircleButton = true;
      showCenterWagersButton = false;
      showCenterSwedenButton = true;
      justMovedToCenter = true;
      const winningLat = Number(winningCoord[0]);
      const winningLng = Number(winningCoord[1]);
      let hasPinAbove = false;
      let hasPinBelow = false;
      let hasPinLeft = false;
      let hasPinRight = false;
      wagerPins.forEach(pin => {
        const _pin$getLatLng = pin.getLatLng(),
          lat = _pin$getLatLng.lat,
          lng = _pin$getLatLng.lng;
        if (lat > winningLat) {
          hasPinAbove = true;
        }
        if (lat < winningLat) {
          hasPinBelow = true;
        }
        if (lng < winningLng) {
          hasPinLeft = true;
        }
        if (lng > winningLng) {
          hasPinRight = true;
        }
      });
      const bounds = leaflet.latLngBounds([(_leaflet$featureGroup = leaflet.featureGroup(wagerPins)) === null || _leaflet$featureGroup === void 0 ? void 0 : _leaflet$featureGroup.getBounds(), (_singleCircles$2 = singleCircles[0]) === null || _singleCircles$2 === void 0 ? void 0 : _singleCircles$2.getBounds()]);
      if (bounds && bounds !== null && bounds !== void 0 && bounds.isValid()) {
        var _map4;
        (_map4 = map) === null || _map4 === void 0 || _map4.fitBounds(bounds, {
          animate: false,
          paddingTopLeft: [hasPinLeft ? 65 : 15, hasPinAbove ? 85 : 45],
          paddingBottomRight: [hasPinRight ? 65 : 15, hasPinBelow ? 85 : 15],
          minZoom,
          maxZoom
        });
      }
      this.updateUI();
    },
    updateUI() {
      let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.showUiCenterWinCircle();
      this.showUiCenterWagers();
      this.showUiCenterSweden();
      this.uiStamp(index);
    },
    resetLabelsOpacity() {
      const mapContainer = document.getElementById(mapId);
      mapContainer === null || mapContainer === void 0 || mapContainer.querySelectorAll('.label').forEach(labelEl => {
        labelEl.style.removeProperty('opacity');
      });
    },
    moveToWinGroup(index) {
      var _singleCircles$newInd;
      let zoomed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.resetLabelsOpacity();
      let newIndex = singleCircles.length - 1 - index;
      if (index === null) {
        newIndex = 0;
      }
      const moveTo = (_singleCircles$newInd = singleCircles[newIndex]) === null || _singleCircles$newInd === void 0 ? void 0 : _singleCircles$newInd.getBounds();
      if (!moveTo) {
        return;
      }
      if (!zoomed) {
        var _map5;
        const moveToCenter = moveTo.getCenter();
        const moveToZoom = map.getBoundsZoom(moveTo);
        (_map5 = map) === null || _map5 === void 0 || _map5.setView([moveToCenter.lat, moveToCenter.lng], moveToZoom, {
          animate: false
        });
        showCenterWinCircleButton = newIndex !== 0;
        showCenterWagersButton = true;
        this.updateUI(newIndex);
      }
    },
    showResult(_ref2) {
      let winGroups = _ref2.winGroups,
        winningLocation = _ref2.winningLocation,
        evtHandlers = _ref2.evtHandlers;
      map.on('layeradd', trackMapLayers);
      Object.assign(eventHandlers, evtHandlers);
      singleWinGroups = winGroups.slice().reverse();
      winningCoord = locationToArray(winningLocation);
      this.addSingleWinPin();
      this.addSingleLabels();
      this.addSingleCircles();
      this.animateMapIn();
      map.off('layeradd', trackMapLayers);
    },
    animateMapIn() {
      tlResult = gsap.timeline();
      if (document.querySelector('.lp-3dpin .pin-image')) {
        tlResult.set("#".concat(mapId, " .lp-3dpin .pin-image"), {
          opacity: 0,
          scale: 0
        });
      }
      if (document.querySelector('.gsap-heart-count')) {
        tlResult.set("#".concat(mapId, " .gsap-heart-count"), {
          opacity: 0,
          scale: 1
        });
      }
      if (document.querySelector("#".concat(mapId, " .leaflet-popup"))) {
        tlResult.set("#".concat(mapId, " .leaflet-popup"), {
          opacity: 0
        }, '<');
      }
      if (document.querySelector('.result-map')) {
        tlResult.to('.result-map', {
          delay: 0.5,
          opacity: 1,
          duration: 1,
          ease: 'power1.out'
        }, '>');
      }

      if (document.querySelector('.pin-single.lp-3dpin .pin-image')) {
        tlResult.to("#".concat(mapId, " .pin-single.lp-3dpin .pin-image"), {
          opacity: 1,
          scale: 1,
          duration: 0.75,
          ease: 'power4.out'
        });
      }

      if (document.querySelector('.pin-wager.lp-3dpin .pin-image')) {
        tlResult.to("#".concat(mapId, " .pin-wager.lp-3dpin .pin-image"), {
          opacity: 1,
          scale: 1,
          duration: 0.9,
          ease: 'power4.out'
        }, '>');
      }
      if (document.querySelector("#".concat(mapId, " .leaflet-popup"))) {
        tlResult.to("#".concat(mapId, " .leaflet-popup"), {
          opacity: 1,
          duration: 0.5,
          delay: 0.4
        }, '<');
      }
      tlResult.play();
    },
    showWagers(wagers, result, evtHandlers) {
      Object.assign(eventHandlers, evtHandlers);
      this.addWagerPins(wagers, result);
      this.animateMapIn();
    },
    removeWagers() {
      wagerPins.forEach(pin => {
        try {
          if (pin && pin.isPopupOpen && pin.isPopupOpen()) {
            pin.closePopup();
          }
        } catch (err) {
          logger.debug('Result map, error closing popup in removeWagers:', err);
        }
        try {
          if (pin && pin.remove) {
            pin.remove();
          }
        } catch (err) {
          logger.debug('Result map, error removing pin in removeWagers:', err);
        }
      });
      wagerPins = [];
    },
    addWagerPins(mapWagers, result) {
      const uniqueWagersLocations = checkDuplicateWagersLocations(mapWagers);
      const wagers = uniqueWagersLocations;
      const hasMultiple = (wagers === null || wagers === void 0 ? void 0 : wagers.length) > 1;
      wagers.sort((a, b) => {
        const A = parseFloat(a.winAmount.replace(',', '.'));
        const B = parseFloat(b.winAmount.replace(',', '.'));
        return A - B;
      });
      const mappedWagers = wagers.map((wager, index) => {
        var _wager$wins, _wager$description, _wager$location;
        const heartPin = get3dPinIcon({
          color: 'red',
          className: 'pin-wager animate-image',
          count: wager.wagerMultiplayed
        });
        const wagerCoords = locationToArray(wager.wager.bets[0].geoBoardData.geoLoc);
        const pin = leaflet.marker(wagerCoords, {
          icon: heartPin,
          autoPanOnFocus: false
        });
        pin.setZIndexOffset((index + 1000) * ((wager === null || wager === void 0 ? void 0 : wager.wagerMultiplayed) || 1));
        pin.addTo(map);
        const match = wager === null || wager === void 0 || (_wager$wins = wager.wins) === null || _wager$wins === void 0 ? void 0 : _wager$wins.find(win => win.drawNumber === (result === null || result === void 0 ? void 0 : result.drawNumber) && productMapping.isSameProduct(win.productId, result === null || result === void 0 ? void 0 : result.productId));
        let text;
        if (match) {
          const val = parseFloat(match.amount.replace(',', '.'));
          text = "Vinst: <strong>".concat(wager.wagerMultiplayed ? formatCurrency(val * wager.wagerMultiplayed) : formatCurrency(val), " kr</strong>");
        } else {
          const closestCircle = result === null || result === void 0 ? void 0 : result.distribution.at(-1).distanceMeters;
          const dist = svs.lyckoplatsen.utils.format.getDistance({
            from: wagerCoords,
            to: winningCoord,
            subMeter: closestCircle
          });
          text = "".concat(dist, " fr\xE5n vinst");
        }
        const content = "<strong class=\"leaflet-popup-header\">".concat((_wager$description = wager.description) !== null && _wager$description !== void 0 ? _wager$description : (_wager$location = wager.location) === null || _wager$location === void 0 ? void 0 : _wager$location.name, "</strong>").concat(text);
        const popup = leaflet.popup({
          autoClose: hasMultiple,
          closeButton: hasMultiple,
          closeOnClick: hasMultiple,
          autoPan: false
        }).setContent(content);
        pin.bindPopup(popup);
        if (!hasMultiple) {
          pin.openPopup();
        }
        pin.off('click');
        pin.on('click', () => pin.isPopupOpen() ? pin.closePopup() : pin.openPopup());
        const pinEl = pin.getElement();
        if (pinEl) {
          pinEl.addEventListener('focus', () => {
            const bounds = map.getBounds();
            const latlng = pin.getLatLng();
            if (!bounds.contains(latlng)) {
              var _eventHandlers$highli;
              this.centerWagers();
              (_eventHandlers$highli = eventHandlers.highlightedWinGroup) === null || _eventHandlers$highli === void 0 || _eventHandlers$highli.call(eventHandlers, null);
              this.updateUI();
            }
          });
        }
        return pin;
      });
      wagerPins = mappedWagers;
    },
    showUiCenterSweden() {
      var _eventHandlers$showCe;
      (_eventHandlers$showCe = eventHandlers.showCenterSwedenButton) === null || _eventHandlers$showCe === void 0 || _eventHandlers$showCe.call(eventHandlers, Boolean(showCenterSwedenButton));
    },
    showUiCenterWagers() {
      var _eventHandlers$showCe2;
      (_eventHandlers$showCe2 = eventHandlers.showCenterWagersButton) === null || _eventHandlers$showCe2 === void 0 || _eventHandlers$showCe2.call(eventHandlers, Boolean(showCenterWagersButton));
    },
    showUiCenterWinCircle() {
      var _eventHandlers$showCe3;
      (_eventHandlers$showCe3 = eventHandlers.showCenterWinCircleButton) === null || _eventHandlers$showCe3 === void 0 || _eventHandlers$showCe3.call(eventHandlers, Boolean(showCenterWinCircleButton));
    },
    uiStamp() {
      var _singleCircles$index, _singleCircles;
      let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      circleIndex = index;
      const circlePath = (_singleCircles$index = singleCircles[index]) === null || _singleCircles$index === void 0 || (_singleCircles$index = _singleCircles$index._path) === null || _singleCircles$index === void 0 || (_singleCircles$index = _singleCircles$index.getAttribute('d')) === null || _singleCircles$index === void 0 ? void 0 : _singleCircles$index.split(/(?=[Mm])/)[0];
      const circleBeforePath = (_singleCircles = singleCircles[index + 1]) === null || _singleCircles === void 0 || (_singleCircles = _singleCircles._path) === null || _singleCircles === void 0 ? void 0 : _singleCircles.getAttribute('d');
      if (circlePath && circleBeforePath) {
        singleCircles[index]._path.setAttribute('d', "".concat(circlePath, " ").concat(circleBeforePath));
      }
    },
    addSingleWinPin() {
      const heartPin = get3dPinIcon({
        color: 'green',
        className: 'pin-single animate-image'
      });
      singelPin = leaflet.marker(winningCoord, {
        icon: heartPin,
        interactive: false
      });
      singelPin.addTo(map);
    },
    addSingleLabels() {
      const labels = [];
      map.createPane('labels');
      singleWinGroups.forEach((circle, index) => {
        let labelDistance = circle.distanceMeters;
        if (singleWinGroups.length - 1 !== index) {
          labelDistance = circle.distanceMeters * 0.96;
        }
        const labelCoord = getSouthCoordinate(winningCoord, Math.trunc(labelDistance));
        const winsTxt = "".concat(formatCurrency(circle.winners), " ").concat(circle.winners === 1 ? 'vinst' : 'vinster');
        const closeHtml = "<a class=\"label-close-button svs-keyboard-focus\" role=\"button\" aria-label=\"Close popup\" href=\"#close\"><span aria-hidden=\"true\">\xD7</span></a>";
        const myIcon = leaflet.divIcon({
          className: "label label-".concat(singleWinGroups.length - 1 - index, " ").concat(circle.distanceMeters < 200 ? 'label-below' : '', " "),
          html: "<div class=\"elevation-100\">".concat(winsTxt, " \xE0 ").concat(formatCurrency(circle.amountSek.slice(0, -3)), " kr<span>").concat(index === singleWinGroups.length - 1 ? 'Toppvinst' : svs.lyckoplatsen.utils.format.formatDistance(circle.distanceMeters), "</span>").concat(closeHtml, "</div>"),
          iconSize: [0, 0]
        });
        const leafletLabel = leaflet.marker(labelCoord, {
          icon: myIcon,
          pane: 'labels',
          keyboard: false
        });
        leafletLabel.addTo(map);
        leafletLabel.on('click', () => {
          const labelEl = leafletLabel.getElement();
          if (labelEl) {
            labelEl.style.opacity = '0';
          }
        });
        labels.push(leafletLabel);
      });
    },
    addSingleCircles() {
      var _eventHandlers$result;
      const circles = [];
      singleWinGroups.forEach((circle, index) => {
        const newIndex = singleWinGroups.length - 1 - index; 
        const leafletCircleArea = leaflet.circle(winningCoord, {
          color: 'transparent',
          className: "stamped-area stamped-area-".concat(newIndex),
          radius: circle.distanceMeters,
          interactive: false,
          renderer: svgRenderer
        });
        leafletCircleArea.on('add', function () {
          var _path$setAttribute;
          const path = this._path;
          const tabIndex = index === 0 ? '-1' : '0';
          path === null || path === void 0 || (_path$setAttribute = path.setAttribute) === null || _path$setAttribute === void 0 || _path$setAttribute.call(path, 'tabindex', tabIndex);
        });
        leafletCircleArea.addTo(map);
        circles.push(leafletCircleArea);
      });
      singleCircles = circles;
      (_eventHandlers$result = eventHandlers.resultRendered) === null || _eventHandlers$result === void 0 || _eventHandlers$result.call(eventHandlers);
    },
    removeResult() {
      mapLayers.forEach(layer => {
        var _layer$remove;
        return layer === null || layer === void 0 || (_layer$remove = layer.remove) === null || _layer$remove === void 0 ? void 0 : _layer$remove.call(layer);
      });
      mapLayers = [];
    },
    removeMap() {
      if (_isDestroying) {
        return;
      }
      _isDestroying = true;

      try {
        if (tlResult) {
          tlResult.eventCallback('onComplete', null);
          tlResult.pause(0);
          tlResult.kill();
          tlResult = null;
        }
      } catch (_unused) {
        logger.debug('Result map, GSAP not removed properly');
      }

      try {
        var _map6;
        (_map6 = map) === null || _map6 === void 0 || _map6.off('resize');
      } catch (_unused2) {
        logger.debug('Result map, map listeners not removed properly');
      }

      try {
        wagerPins.forEach(p => {
          try {
            if (p && p.isPopupOpen && p.isPopupOpen()) {
              p.closePopup();
            }
          } catch (err) {
            logger.debug('Result map, error closing wager pin popup:', err);
          }
        });
      } catch (err) {
        logger.debug('Result map, error processing wager pin popups:', err);
      }

      try {
        if (map && typeof map.closePopup === 'function') {
          const hasPopup = map._popup;
          if (hasPopup && typeof hasPopup.close === 'function') {
            map.closePopup();
          }
        }
      } catch (err) {
        logger.debug('Result map, error closing map popup:', err);
      }
      try {
        if (map && typeof map.closeTooltip === 'function') {
          const hasTooltip = map._tooltip;
          if (hasTooltip && typeof hasTooltip.close === 'function') {
            map.closeTooltip();
          }
        }
      } catch (err) {
        logger.debug('Result map, error closing map tooltip:', err);
      }
      try {
        intervalPins.forEach(p => {
          try {
            if (p && p.remove) {
              p.remove();
            }
          } catch (err) {
            logger.debug('Result map, error removing interval pin:', err);
          }
        });
        intervalPins = [];
      } catch (err) {
        logger.debug('Result map, error clearing interval pins:', err);
      }
      try {
        wagerPins.forEach(p => {
          try {
            if (p && p.remove) {
              p.remove();
            }
          } catch (err) {
            logger.debug('Result map, error removing wager pin:', err);
          }
        });
        wagerPins = [];
      } catch (err) {
        logger.debug('Result map, error clearing wager pins:', err);
      }
      try {
        mapLayers.forEach(l => {
          try {
            if (l && l.remove) {
              l.remove();
            }
          } catch (err) {
            logger.debug('Result map, error removing map layer:', err);
          }
        });
        mapLayers = [];
      } catch (err) {
        logger.debug('Result map, error clearing map layers:', err);
      }
      try {
        if (singelPin && singelPin.remove) {
          singelPin.remove();
        }
        singelPin = null;
      } catch (err) {
        logger.debug('Result map, error removing single pin:', err);
      }
      try {
        singleCircles.forEach(c => {
          try {
            if (c && c.remove) {
              c.remove();
            }
          } catch (err) {
            logger.debug('Result map, error removing single circle:', err);
          }
        });
        singleCircles = [];
      } catch (err) {
        logger.debug('Result map, error clearing single circles:', err);
      }

      try {
        const container = document.getElementById(mapId);
        container === null || container === void 0 || container.querySelectorAll('.world-rect, .pin-wager, .pin-single, .label, .stamped-area, .gsap-heart-count').forEach(el => el.remove());
      } catch (_unused3) {
        logger.debug('Result map, dom elements removed properly');
      }

      try {
        if (map) {
          var _map$stop, _map7;
          (_map$stop = (_map7 = map).stop) === null || _map$stop === void 0 || _map$stop.call(_map7);
          map.off();
          map.remove();
          map = null;
        }
      } catch (_unused4) {
        logger.debug('Result map, the map is not removed properly');
      }

      mapId = null;
      singleWinGroups = [];
      circleIndex = 0;
      winningCoord = null;
      showCenterWinCircleButton = false;
      showCenterWagersButton = false;
      showCenterSwedenButton = false;
      _isDestroying = false;
    }
  };
}
Object.assign(svs.lyckoplatsen.components.shared_map, {
  getResultMapHandler
});

 })(window);